var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 232,
    viewBox: "0 0 331 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_546_10840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160 0L204.325 74L219.705 54.6623L228.222 43.9475L160 0Z",
    fill: "url(#paint0_linear_546_10840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 0L240.357 29.7716L261 21.8759L160 0Z",
    fill: "url(#paint1_linear_546_10840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 0L228.222 43.9475L242.366 60.9226L240.357 29.7716L160 0Z",
    fill: "url(#paint2_linear_546_10840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.705 54.6623L242.366 60.9226L228.222 43.9475L219.705 54.6623Z",
    fill: "url(#paint3_linear_546_10840)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.495 68.1466C264.411 69.7013 267.456 71.4454 270.572 73.3645C273.158 74.9576 273.963 78.3456 272.37 80.9319C270.777 83.5183 267.389 84.3235 264.803 82.7304C261.877 80.9281 259.03 79.298 256.32 77.8534L261.495 68.1466ZM280.01 86.2609C281.889 83.8736 285.347 83.4609 287.734 85.3392C293.118 89.5757 298.436 94.2645 303.395 99.3437C305.517 101.517 305.475 104.999 303.302 107.121C301.128 109.243 297.646 109.201 295.524 107.028C290.942 102.334 285.99 97.9633 280.932 93.9842C278.545 92.106 278.132 88.6481 280.01 86.2609ZM309.281 114.269C311.793 112.561 315.214 113.212 316.922 115.723C321.023 121.751 324.46 128.192 326.85 134.972C327.86 137.837 326.357 140.978 323.492 141.988C320.627 142.998 317.486 141.495 316.476 138.63C314.455 132.898 311.495 127.301 307.828 121.911C306.119 119.399 306.77 115.978 309.281 114.269ZM56.9271 126.568C49.5943 126.016 42.4441 126.315 35.6285 127.629C32.6458 128.204 29.7618 126.252 29.187 123.269C28.6122 120.286 30.5641 117.402 33.5468 116.828C41.4576 115.303 49.5986 114.985 57.7539 115.6C60.7829 115.828 63.0533 118.468 62.8249 121.497C62.5966 124.526 59.956 126.797 56.9271 126.568ZM74.504 123.62C75.2973 120.688 78.3174 118.954 81.2495 119.748C88.8315 121.799 96.3098 124.47 103.529 127.563C106.321 128.759 107.614 131.992 106.418 134.784C105.222 137.577 101.988 138.87 99.1963 137.674C92.3923 134.758 85.4023 132.267 78.3765 130.366C75.4444 129.573 73.7106 126.552 74.504 123.62ZM18.0243 127.385C19.566 130.002 18.6942 133.374 16.077 134.915C13.1431 136.644 10.3051 138.663 7.58119 141L0.418701 132.651C3.6349 129.892 7.00136 127.495 10.4938 125.438C13.111 123.896 16.4825 124.768 18.0243 127.385ZM117.023 140.107C118.535 137.473 121.896 136.563 124.531 138.075C131.596 142.13 138.218 146.472 144.206 150.875C146.653 152.675 147.178 156.117 145.378 158.564C143.579 161.011 140.136 161.536 137.689 159.737C132.034 155.578 125.759 151.463 119.055 147.615C116.421 146.103 115.511 142.742 117.023 140.107ZM325.112 151.212C328.149 151.281 330.554 153.799 330.485 156.836C330.322 163.979 328.805 171.256 325.674 178.566C324.478 181.358 321.245 182.652 318.453 181.456C315.66 180.26 314.366 177.027 315.562 174.235C318.147 168.201 319.358 162.308 319.488 156.585C319.557 153.548 322.075 151.142 325.112 151.212ZM154.475 166.172C156.62 164.021 160.102 164.016 162.253 166.161C165.384 169.282 168.107 172.348 170.316 175.272C172.096 177.63 174.123 180.107 176.375 182.639C178.394 184.909 178.191 188.385 175.921 190.404C173.651 192.423 170.175 192.219 168.156 189.949C165.716 187.207 163.503 184.503 161.539 181.903C159.705 179.476 157.341 176.796 154.487 173.951C152.336 171.806 152.33 168.324 154.475 166.172ZM313.443 189.301C315.785 191.235 316.116 194.702 314.181 197.044C311.99 199.698 309.562 202.339 306.889 204.967C304.294 207.518 301.681 209.864 299.053 212.015C296.702 213.939 293.237 213.593 291.313 211.243C289.389 208.892 289.735 205.427 292.085 203.503C294.445 201.572 296.811 199.449 299.178 197.122C301.598 194.744 303.766 192.382 305.7 190.04C307.634 187.698 311.101 187.367 313.443 189.301ZM182.38 196.701C184.344 194.383 187.814 194.096 190.132 196.06C194.881 200.085 200.075 203.921 205.615 207.312C208.205 208.898 209.02 212.284 207.434 214.875C205.848 217.465 202.463 218.28 199.872 216.694C193.798 212.977 188.15 208.799 183.021 204.453C180.703 202.489 180.416 199.018 182.38 196.701ZM283.793 216.214C285.138 218.937 284.02 222.235 281.296 223.58C274.493 226.94 267.68 229.142 260.928 230.352C257.938 230.888 255.08 228.898 254.544 225.908C254.008 222.918 255.998 220.06 258.987 219.524C264.71 218.499 270.538 216.625 276.426 213.717C279.149 212.372 282.448 213.49 283.793 216.214ZM215.51 218.899C216.573 216.054 219.742 214.609 222.587 215.672C228.434 217.856 234.482 219.394 240.656 220.087C243.675 220.426 245.847 223.147 245.509 226.166C245.17 229.185 242.448 231.357 239.43 231.019C232.253 230.213 225.324 228.437 218.738 225.976C215.892 224.913 214.447 221.745 215.51 218.899Z",
    fill: "#FCE1D3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_546_10840",
    x1: 224.268,
    y1: 27.0272,
    x2: 169.313,
    y2: 39.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F09787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D95A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_546_10840",
    x1: 248.523,
    y1: 3.43742,
    x2: 157.599,
    y2: 24.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F09787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D95A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_546_10840",
    x1: 208.22,
    y1: 18.1149,
    x2: 199.746,
    y2: 32.8061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F09787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D95A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_546_10840",
    x1: 240.112,
    y1: 51.2848,
    x2: 220.008,
    y2: 55.9804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F09787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D95A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC4900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_546_10840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 74,
    fill: "white",
    transform: "translate(160)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.aa50918f6d55272208b4d89f9ea76b1f.svg";
export { ForwardRef as ReactComponent };